import { buildApiUrl } from '../config/environment';
import { getAuthToken } from './authService';

const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const listSubscriptions = async ({ page = 1, limit = 200 } = {}) => {
  const response = await fetch(
    buildApiUrl(`/admin/subscriptions?page=${page}&limit=${limit}`),
    { method: 'GET', headers: getAuthHeaders() }
  );
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to fetch subscriptions');
  }
  return response.json(); // { data, total, page, limit }
};

export const updateSubscription = async (id, { plan, status, expires_at = null }) => {
  const response = await fetch(buildApiUrl(`/admin/subscriptions/${id}`), {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify({ plan, status, expires_at }),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err.error || 'Failed to update subscription');
  }
  return response.json();
};

const matchesAgency = (s, agencyId) =>
  s.managing_entity?.agency_id === agencyId ||
  s.managing_entity?.agency?.id === agencyId;

// Return the subscription belonging to a given agency ID.
// TODO: replace with a backend entity-scoped endpoint
// (e.g. GET /admin/subscriptions?entity_type=agency&entity_id=<id>) when available —
// pagination below is a stopgap so agencies past the first page aren't silently missed.
export const getSubscriptionForAgency = async (agencyId) => {
  const limit = 200;
  let page = 1;

  // Loop pages until the agency is found or the list is exhausted.
  // eslint-disable-next-line no-constant-condition
  while (true) {
    const result = await listSubscriptions({ page, limit });
    const subs = result.data || result;
    if (!Array.isArray(subs) || subs.length === 0) return null;

    const match = subs.find((s) => matchesAgency(s, agencyId));
    if (match) return match;

    const total = result.total;
    const fetched = page * limit;
    // Stop when we've seen the reported total, or the page came back short.
    if (subs.length < limit || (typeof total === 'number' && fetched >= total)) {
      return null;
    }
    page += 1;
  }
};
